import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { CalculateClaimEstimationResponseDto } from "../../dtos/calculate-claim-estimation-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetClaimEstimationQueryParams = {
  orderIds: string[];
  options?: Omit<
    UseQueryOptions<CalculateClaimEstimationResponseDto>,
    "queryKey" | "queryFn"
  >;
};

export const useGetClaimEstimationQuery = ({
  orderIds,
  options
}: UseGetClaimEstimationQueryParams) => {
  return useQuery({
    queryKey: OrderQueryKeys.calculateClaimEstimation(orderIds).queryKey,
    queryFn: async () =>
      await OrderService.calculateClaimEstimation({
        payload: { order_ids: orderIds }
      }),
    enabled: orderIds.length > 0,
    staleTime: Infinity,
    ...options
  });
};
